import {
  RECOMMENDATION_INVALID_FIELD_TAB_BY_FIELD,
  RecommendationInvalidFieldTabKey
} from 'src/app/constants/recommendation-invalid-field-tab.constants';

export function resolveRecommendationInvalidFieldTabIndex(fieldName: string, hasHiddenFieldsTab: boolean): number {
  const tabKey = RECOMMENDATION_INVALID_FIELD_TAB_BY_FIELD[fieldName] ?? 'basic';

  switch (tabKey as RecommendationInvalidFieldTabKey) {
    case 'assessors':
      return 0;
    case 'auditors':
      return 1;
    case 'basic':
      return 2;
    case 'files':
      return 3;
    case 'logs':
      return 4;
    case 'hidden':
      return hasHiddenFieldsTab ? 5 : 2;
    default:
      return 2;
  }
}
